import moment from "moment/moment";
import Action from "../Actions/Action";
import AutomatisationCard from "../Actions/AutomatisationCard";
import useAutoActions, {
  useProfileBailleurAutoActions,
  type AutoAction,
  type AutoActionAssociation,
} from "../../hooks/use-auto-actions";
// @ts-expect-error pure js
import { AutoActionType } from "../../utils/constants/autoActions.js";

interface AutomatisationProfileBailleurProps {
  profileBailleur: { id: number };
}

const crgAction = {
  nom: "Compte rendu de gestion",
  static_id: AutoActionType.CRG,
  commentaires:
    "Génère automatiquement le compte rendu de gestion le 1er de chaque mois et l'envoie par email.",
};

export default function AutomatisationProfileBailleur({
  profileBailleur,
}: AutomatisationProfileBailleurProps) {
  const { autoActions } = useAutoActions();
  const {
    profileBailleurAutoActions,
    profileBailleurAutoActionsByName,
    createProfileBailleurAutoAction,
    deleteProfileBailleurAutoAction,
    updateProfileBailleurAutoAction,
    refresh,
  } = useProfileBailleurAutoActions(profileBailleur.id);

  if (!profileBailleurAutoActions) return null;

  const crgAutoAction = profileBailleurAutoActionsByName[AutoActionType.CRG];

  async function onToggle(
    e: React.ChangeEvent<HTMLInputElement>,
    action: Pick<AutoAction, "static_id">,
    profileBailleurAutoAction?: AutoActionAssociation,
  ) {
    try {
      if (e.target.checked) {
        const payload: Partial<AutoActionAssociation> = {
          nom_auto_action: action.static_id,
        };
        if (action.static_id === AutoActionType.CRG) {
          payload.action_date = moment()
            .add(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD");
        }
        await createProfileBailleurAutoAction(payload);
      } else {
        await deleteProfileBailleurAutoAction(profileBailleurAutoAction!.id);
      }
      refresh();
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <AutomatisationCard subtitle="Créez ici les templates d'automatisation. Les nouveaux locataires seront créés avec les automatisations sélectionnées activées par défaut.">
      {autoActions?.map((action, i) => {
        const profileBailleurAutoAction =
          profileBailleurAutoActionsByName[action.static_id];
        const checked = !!profileBailleurAutoAction;
        return (
          <Action
            action={action}
            checked={checked}
            autoActionAssociation={profileBailleurAutoAction}
            onUpdate={updateProfileBailleurAutoAction}
            onToggle={onToggle}
            requiresWrite
            key={i}
          />
        );
      })}
      <Action
        action={crgAction}
        checked={!!crgAutoAction}
        autoActionAssociation={crgAutoAction}
        onUpdate={updateProfileBailleurAutoAction}
        onToggle={onToggle}
        requiresWrite
      />
    </AutomatisationCard>
  );
}
